import { InjectionToken } from '@angular/core';
import { RolesPort } from './roles.port';

export const ROLES_PORT = new InjectionToken<RolesPort>('ROLES_PORT');